import { isValid, parse } from "date-fns";

export const parseMultiple = (
  dateString: string,
  formatString: string[],
  referenceDate: Date
) => {
  let result = new Date();

  if (Array.isArray(formatString)) {
    for (let i = 0; i < formatString.length; i++) {
      result = parse(dateString, formatString[i], referenceDate);
      if (isValid(result)) {
        break;
      }
    }
  } else {
    result = parse(dateString, formatString, referenceDate);
  }

  return result;
};
